export default "__VITE_ASSET__DKeU9F0q__"